export default {
  mutateAddedProject(state, data) {
    state.addedProject = data;
  },
};
